import { CloseOutlined } from '@ant-design/icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons';
import styled from 'styled-components';

const AlertWrapper = styled.div`
  position: relative;
  background: #fff;
  border-radius: 8px;
  padding: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  border-left: 4px solid #1890ff;

  .close-btn {
    position: absolute;
    top: 12px;
    right: 12px;
    cursor: pointer;
    color: #999;
    font-size: 14px;
    &:hover {
      color: #333;
    }
  }

  .alert-header {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 12px;

    .location-icon {
      color: #1890ff;
      font-size: 18px;
    }

    .title {
      font-family: Lato, sans-serif;
      font-size: 16px;
      font-weight: 700;
      color: #333;
      margin: 0;
    }
  }

  .alert-message {
    font-family: Lato, sans-serif;
    font-size: 14px;
    line-height: 1.5;
    color: #555;
    margin: 0;
    padding-right: 24px;
  }
`;

interface Props {
  alertContent: string | null;
  setAlertContent: (val: string | null) => void;
}

const LocationValidatorAlert: React.FC<Props> = ({
  alertContent,
  setAlertContent
}) => {
  return (
    <AlertWrapper>
      <CloseOutlined
        className="close-btn"
        onClick={() => setAlertContent(null)}
      />
      <div className="alert-header">
        <FontAwesomeIcon icon={faMapMarkerAlt} className="location-icon" />
        <p className="title">Location Alert</p>
      </div>
      <p className="alert-message">{alertContent}</p>
    </AlertWrapper>
  );
};

export default LocationValidatorAlert;
